import { createContext } from 'react';
import { IItemForGetShortInfo, IDishPositionItem } from 'types';

export type TChangeDishPositionSelectedItem = Nullable<string>;
export type TTypeOfChangeDishPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeDishPositionState {
	IDSelectedCustomer: TChangeDishPositionSelectedItem;
	IDSelectedRestaurant: TChangeDishPositionSelectedItem;
	IDSelectedCategory: TChangeDishPositionSelectedItem;
	IDSelectedSubCategory: TChangeDishPositionSelectedItem;
	positionsData: IDishPositionItem[];
	typeOfModalWindow: TTypeOfChangeDishPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
}

export const changeDishPositionInitialState: IChangeDishPositionState = {
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedCategory: null,
	IDSelectedSubCategory: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	fetchedRestaurants: [],
};

export interface IChangeDishPositionContext extends IChangeDishPositionState {
	setIDCustomer(value: TChangeDishPositionSelectedItem): void;
	setIDRestaurant(value: TChangeDishPositionSelectedItem): void;
	setIDCategory(value: TChangeDishPositionSelectedItem): void;
	setIDSubCategory(value: TChangeDishPositionSelectedItem): void;
	resetSelectedControls(): void;
	setPositionsData(data: IDishPositionItem[]): void;
	reorderItems(value: IDishPositionItem[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeDishPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: string[]): void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

export const ChangeDishPositionContext = createContext<IChangeDishPositionContext>({
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDCategory: () => undefined,
	setIDSubCategory: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	setFetchedRestaurants: () => undefined,
	...changeDishPositionInitialState,
});
